export const fmtDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const festivals = {
  "2026-11-08": "Deepavali",
  "2026-11-24": "Karthika Deepam",
  "2026-12-31": "Vaikuntha Ekadasi",
  "2027-01-14": "Makara Sankranti",
  "2027-02-26": "Maha Shivaratri",
  "2027-03-19": "Ugadi",
  "2027-03-26": "Sri Rama Navami",
};

export const festivalOn = (dateStr) => festivals[dateStr] || null;

export const todayFestival = () => festivalOn(fmtDay(new Date()));
